export default __webpack_public_path__ + "static/media/JeepLanding.91c784c6.png";